import { render, staticRenderFns } from "./BTable.vue?vue&type=template&id=a7562a5a&"
import script from "./BTable.vue?vue&type=script&lang=js&"
export * from "./BTable.vue?vue&type=script&lang=js&"
import style0 from "./BTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports